import { render, staticRenderFns } from "./ResellerClaimTrans.vue?vue&type=template&id=20116f85&"
import script from "./ResellerClaimTrans.vue?vue&type=script&lang=js&"
export * from "./ResellerClaimTrans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports